$(document).ready(function () {
    console.log("ready");

    $("a").each(function () {
        if ($(this).data("href")) {
            $(this).click(function (e) {
                if ($($(this).data("href")).length) {
                    e.preventDefault();
                    console.log($(this).data("href"));

                    $([document.documentElement, document.body]).animate(
                        {
                            scrollTop: $($(this).data("href")).offset().top,
                        },
                        1000
                    );
                }
            });
        }
    });
});
